import { render, staticRenderFns } from "./recap-produits.html?vue&type=template&id=2e489c93&scoped=true&external"
import script from "./recap-produits.js?vue&type=script&lang=js&external"
export * from "./recap-produits.js?vue&type=script&lang=js&external"
import style0 from "./recap-produits.scss?vue&type=style&index=0&id=2e489c93&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e489c93",
  null
  
)

export default component.exports